import logo from "../images/RTH_LOGO.png";

export default function Logo(props) {
    return (
        <img src={logo} style={{ height:props.height ?? "28px", width: "auto" }} alt="Realtour Logo" />
    )
}